<!-- 详情_tabs -->
<template>
  <div :class="{ tabs: true, tabsFixed: tabFixed }">
    <div :class="{ chapterTabs: true }">
      <div
        v-for="(item, index) in tabsList"
        @click="cutTab(index, item.label)"
        :class="{ active: tabSelected == index }"
        :key="index"
      >
        <p>{{ item.name }}</p>
        <span></span>
      </div>
    </div>
    <!--  tab content -->
    <div
      class="tabContent"
      :class="[{ grayBg: activeName === 'fourth' }, { wxFoot: this.$root.$data.isApp }]"
    >
      <div v-if="activeName === 'first'">
        <div class="courseIntroduce" v-html="introduction.introduction"></div>
      </div>
      <div v-if="activeName === 'second'">
        <div v-if="!isFaceCourse">
          <!-- 目录树 -->
          <CourseTree :treeNodeInit="containCurriculumData.courseNodes" />
          <EmptyData :emptyName="'tree'" v-if="!containCurriculumData.courseNodes" />
        </div>
        <div class="school" v-else>
          <img v-for="(item, index) in schoolImg" :key="index" :src="item" alt="" />
        </div>
      </div>
      <div v-show="activeName === 'third'">
        <TeacherIntroduceModule></TeacherIntroduceModule>
      </div>
      <div v-show="activeName === 'fourth'">
        <evaluationList @evaluationTotal="evaluationTotal"  source="product"/>
      </div>
    </div>
    <Foot :class="{ footActive: this.$root.$data.isSafari }" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import EmptyData from '@/components/emptyData/emptyData.vue';
import { reqProducts, reqRecommendList } from '@/api/home';
import { reqCombinationlist } from '@/api/combination';
import { reqClassType } from '@/api/courseDetail';

// eslint-disable-next-line import/extensions
import evaluationList from '@/pages/learningGuidePage/evaluation/evaluationList';
import Foot from '@/components/foot/privacy.vue';
import TeacherIntroduceModule from '../../components/branchSchoolCourseDetail/teacherIntroduceModule/TeacherIntroduceModule.vue';
import CourseTree from '../../components/course/CourseTree.vue';

export default {
  data() {
    return {
      tabsList: [
        { name: '课程介绍', label: 'first' },
        { name: '课程目录', label: 'second' },
        { name: '师资介绍', label: 'third' },
        { name: '评价', label: 'fourth' },
      ],
      activeName: 'first', // 当前选中的tab
      tabSelected: 0, // 被选中的tab
      introduction: {}, // 课程介绍
      productIdList: [], // 好课推荐课id list
      recommendDataList: [], // 好课推荐课data list
      goodCourseFlag: false,
      isFaceCourse: false,
      schoolImg: [], // 校区介绍
    };
  },
  props: ['tabFixed'],
  components: {
    TeacherIntroduceModule,
    CourseTree,
    evaluationList,
    Foot,
    EmptyData,
  },
  watch: {
    courseBaseData(data) {
      this.checkFaceCourse();
      if (data && data.productIntroductionRespVOList) {
        this.introduction = data.productIntroductionRespVOList.find(
          (ele) => ele.terminalType === 2,
        );
      }
    },
  },
  computed: {
    ...mapState(['courseBaseData', 'containCurriculumData', 'buyStatus']),
  },
  created() {},
  mounted() {

    document.body.addEventListener('click', (event) => {
      event.stopImmediatePropagation();
      // 兼容处理
      const { target } = event;
      const parentNodeName = target.parentNode.nodeName;
      // 判断是否匹配目标元素
      if (parentNodeName.toLocaleLowerCase() === 'a') {
        // 对捕获到的 a 标签进行处理，需要先禁止它的跳转行为
        if (event.preventDefault) {
          event.preventDefault();
        } else {
          window.event.returnValue = true;
        }

        // 处理完 a 标签的内容，重新触发跳转，根据原来 a 标签页 target 来判断是否需要新窗口打开
        const url = target.parentNode.getAttribute('href');

        if (this.$root.$data.isApp) {
          this.$sendToApp('openNewWebView', { url }, false);
          return;
        }
        if (target.parentNode.getAttribute('target') === '_blank') {
          window.open(url);
        } else {
          window.location.href = url;
        }
      }
    });
  },

  methods: {
    checkFaceCourse() {
      const { productCategoryName, productAttributeRespVOS } = this.courseBaseData;
      // eslint-disable-next-line no-unused-expressions
      (productAttributeRespVOS || []).forEach((element) => {
        if (element.extendAttributeNameEn === 'learningEn') {
          this.schoolImg = JSON.parse(element.dataJson || '[]');
        }
        if (element.extendAttributeNameEn === 'classType' && this.$root.miniprogram) {
          reqClassType().then((data) => {
            const status = data?.data.find((ele) => ele.value === element.dataJson);
            this.$root.setMiniProgramBuy(status);
          });
        }
      });
      if (productCategoryName?.indexOf('线下课程') > -1) {
        this.isFaceCourse = true;
        if (!this.schoolImg.length) {
          this.tabsList.splice(1, 1);
          return;
        }
        const idx = 1;
        this.tabsList[idx] = {
          name: '校区介绍',
          label: 'second',
        };
      }
    },
    evaluationTotal(val) {
      this.tabsList.forEach((item) => {
        if (item.name === '评价' && val > 0) {
          if (val > 99) {
            // eslint-disable-next-line no-param-reassign
            item.name = '评价(99+)';
          } else {
            // eslint-disable-next-line no-param-reassign
            item.name = `评价(${val})`;
          }
        }
      });
    },
    // 切换tab
    cutTab(index, label) {
      this.activeName = label;
      this.tabSelected = index;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .common-foot {
  position: relative;
  bottom: auto;
  z-index: 1;
}
::v-deep .footActive.common-foot {
  padding-bottom: 220px;
}
.tabs {
  position: relative;
  background: #fff;
  $pubColor: #ff6c02;
  .chapterTabs {
    /* tabs label */
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 94px;
    background: #fff;
    border-bottom: 2px solid rgba(120, 120, 120, 0.2);
    border-radius: 14px 14px 0 0;
    > div {
      position: relative;
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: center;
      height: 100%;
      background: #fff;
      p {
        width: 100%;
        color: #333;
        font-weight: 500;
        font-size: 29px;
        text-align: center;
        border-right: 2px solid #edf1f6;
      }
    }
    .active {
      /* 被选中状态 */
      > p {
        color: $pubColor;
      }
      &::before {
        position: absolute;
        bottom: 0;
        width: 45px;
        height: 5px;
        background-color: $pubColor;
        content: ' ';
      }
    }
    > div:last-child {
      p {
        border: none;
      }
    }
  }
  .tabContent {
    /* tab content */
    width: 100%;
    min-height: calc(100vh - 600px);
    // padding: 36px 36px 100px 36px;
    // padding-bottom: 120px;
    background-color: #fff;
    .goodCourseContent {
      background: #f9f9f9;
    }
    .courseIntroduce {
      width: 100%;
      padding: 36px;
      font-size: 28px;
      ::v-deep img {
        width: 100%;
      }
    }
    .evaluation-tab {
      .evaluation-list-page {
        min-height: calc(100vh - 216px);
      }
    }
  }

  .grayBg {
    background: #f9f9f9;
  }

  .evaluation-list-page {
    min-height: calc(100vh - 334px);

    ::v-deep .van-pull-refresh {
      min-height: calc(100vh - 5.41rem);
    }

    ::v-deep .emptyIndent {
      height: calc(100vh - 380px);
    }
  }
}
.tabsFixed {
  .chapterTabs {
    position: fixed;
    top: 0;
    z-index: 9;
  }
  .tabContent {
    margin-top: 94px;
  }
}
::v-deep .emptyIndent .hide {
  display: none;
}
.school {
  // padding: 40px;
  img {
    width: 100%;
  }
}

.wxFoot {
  padding-bottom: 100px;
}
</style>
